<template>
  <div class="form-group"
       :class="[
       {'input-group': hasIcon},
       {'has-danger': error},
       {'input-group-focus': focused},
       {'has-label': label || $slots.label}]">
    <slot name="label">
      <label v-if="label" :class="labelClasses">
        {{label}}
        <span v-if="required">*</span>
      </label>
    </slot>

    <slot name="addonLeft">
      <div v-if="addonLeftIcon" class="input-group-prepend">
        <span class="input-group-text">
          <i :class="addonLeftIcon"></i>
        </span>
      </div>
    </slot>
    <slot>
      <input
        :value="value"
        v-on="listeners"
        v-bind="$attrs"
        class="form-control"
        :class="[{valid: value && !error}, inputClasses]"
        aria-describedby="addon-right addon-left">
    </slot>
    <slot name="addonRight">
        <span v-if="addonRightIcon" class="input-group-append">
          <span class="input-group-text">
            <i :class="addonRightIcon"></i>
          </span>
        </span>
    </slot>

    <slot name="infoBlock"></slot>
    <slot name="helpBlock">
      <div class="text-danger invalid-feedback" style="display: block;" :class="{'mt-2': hasIcon}" v-if="error">
        {{ error }}
      </div>
    </slot>
  </div>
</template>
<script>
  export default {
    inheritAttrs: false,
    name: 'fg-input',
    props: {
      required: Boolean,
      label: String,
      error: String,
      labelClasses: String,
      inputClasses: String,
      value: {
        type: [String, Number],
        default: ''
      },
      addonRightIcon: String,
      addonLeftIcon: String,
      trim: Boolean
    },
    data() {
      return {
        focused: false
      }
    },
    computed: {
      listeners() {
        return {
          ...this.$listeners,
          input: this.updateValue,
          focus: this.onFocus,
          blur: this.onBlur,
          paste: this.onPaste
        }
      },
      hasIcon() {
        const {addonRight, addonLeft} = this.$slots;
        return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined
      }
    },
    methods: {
      normalizeValue(value) {
        if (!this.trim || value == null) {
          return value;
        }
        return String(value).trim();
      },
      updateValue(evt) {
        this.$emit('input', this.normalizeValue(evt.target.value));
      },
      onPaste() {
        if (!this.trim) {
          return;
        }
        this.$nextTick(() => {
          const input = this.$el.querySelector('input');
          if (!input) {
            return;
          }
          const normalized = this.normalizeValue(input.value);
          if (normalized !== this.value) {
            this.$emit('input', normalized);
          }
        });
      },
      onFocus(value){
        this.focused = true;
        this.$emit('focus', value);
      },
      onBlur(evt){
        this.focused = false;
        if (this.trim) {
          const normalized = this.normalizeValue(this.value);
          if (normalized !== this.value) {
            this.$emit('input', normalized);
          }
        }
        this.$emit('blur', evt);
      }
    }
  }
</script>
<style>

</style>
